<template>
  <div
    :style="{ width: width, height: height }"
    class="echartsBarBattery"
    ref="echartsBarBattery"
  ></div>
</template>

<script>
import * as echarts from "echarts";
import {
  addResizeListener,
  removeResizeListener,
} from "element-ui/src/utils/resize-event";
export default {
  name: "echarts-bar-battery",
  props: {
    // 宽
    width: {
      type: [Number, String],
      default: "100%",
    },
    // 高度
    height: {
      type: [Number, String],
      default: "100%",
    },
    // 数据
    yData: {
      type: [Array, Object],
      default: () => ["传感器故障", "电机故障", "导轨故障", "轴承故障", "断线"],
    },
    // 数据
    data: {
      type: [Array, Object],
      default: () => [720, 44, 63, 70, 1000],
    },
  },
  data() {
    return {
      myChart: null,
    };
  },
  watch: {
    data: {
      handler() {
        this.init();
      },
      deep: true,
    },
    yData: {
      handler() {
        this.init();
      },
      deep: true,
    },
    height: {
      handler() {
        this.init();
      },
      deep: true,
    },
  },
  methods: {
    init() {
      let maxData = this.data.reduce((a, b) => a + b, 0);
      this.myChart = echarts.init(this.$refs["echartsBarBattery"]);
      let option = {
        tooltip: {
          show: false,
        },
        xAxis: {
          max: maxData,
          splitLine: { show: false },
          offset: 10,
          axisLine: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
        },
        yAxis: {
          data: this.yData,
          inverse: true,
          axisTick: { show: false },
          axisLine: { show: false },
          axisLabel: {
            // align: "left",
            color: "#fff",
            fontSize: 16,
          },
        },
        grid: {
          top: 0,
          width: 280,
          height: this.data.length * 40,
          left: "23%",
          right: "15%",
        },
        series: [
          {
            //内
            type: "bar",
            barWidth: 18,
            legendHoverLink: false,
            symbolRepeat: true,
            silent: true,
            itemStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 1,
                y2: 0,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(57, 171, 255, 1)", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(161, 255, 227, 1)", // 100% 处的颜色
                  },
                ],
              },
            },
            data: this.data,
            z: 1,
            animationEasing: "elasticOut",
          },
          {
            // 背景
            type: "pictorialBar",
            label: {
              show: true,
              position: "right",
              offset: [10, 0],
              color: "rgba(255,255,255,0.5)",
              fontSize: 16,
            },
            animationDuration: 0,
            symbolRepeat: "fixed",
            symbolMargin: "20%",
            symbol: "rect",
            symbolSize: [4, 18],
            itemStyle: {
              normal: {
                color: "rgba(255,255,255,0.1)",
              },
            },
            data: this.data,
            z: 0,
            animationEasing: "elasticOut",
          },
          {
            //分隔
            type: "pictorialBar",
            itemStyle: {
              color: "#000",
            },
            symbolRepeat: "fixed",
            symbolMargin: 2,
            symbol: "rect",
            symbolClip: true,
            symbolSize: [2, 18],
            symbolPosition: "start",
            symbolOffset: [0, 0],
            data: this.data,
            z: 2,
            animationEasing: "elasticOut",
          },
        ],
      };
      this.myChart.setOption(option);
      window.addEventListener("resize", () => {
        this.myChart.resize(); //当浏览器窗口大小发生变化时，图表可以进行自适应
      });
    },
    getDom() {
      return this.$refs["echartsBarBattery"];
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
      addResizeListener(this.getDom(), this.myChart?.resize);
    });
  },
  beforeDestroy() {
    removeResizeListener(this.getDom(), this.myChart?.resize);
    this.myChart && this.myChart.dispose();
  },
};
</script>

<style scoped></style>
